<script>
	import { page } from '$app/state';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	let {
		backgroundColor = page.data?.indowPro ? 'grey-light-medium' : 'white',
		backgroundImage = null,
		title = null,
		id = null,
		style = null,
		imageColumn = null,
		columnPosition = 'right',
		imageColumnAfter = null,
		imageColumnAlt = null,
		class: className = null,
		innerClass = null,
		imageColumnClass = null,
		backgroundImageClass = null,
		backgroundImageContainerClass = null,
		loading = 'lazy',
		children,
	} = $props();
</script>

<section
	{id}
	class={[
		`
    full-width relative isolate z-10 grid w-full flex-auto place-items-center
    content-start items-center
    *:last:mb-0
    [&_>picture:not(:last-child)>img]:mb-4
  `,
		className,
		{ 'bg-indow-white': backgroundColor == 'white' },
		{ 'bg-indow-blue': backgroundColor == 'blue' },
		{ 'bg-indow-grey': backgroundColor == 'grey' },
		{ 'bg-indow-grey-light': backgroundColor == 'grey-light' },
		{
			'bg-indow-grey-light-medium': backgroundColor == 'grey-light-medium',
		},
		{ 'bg-indow-grey-medium': backgroundColor == 'grey-medium' },
		{ 'bg-indow-grey-dark': backgroundColor == 'grey-dark' },
		{ 'bg-indow-grey-blue': backgroundColor == 'grey-blue' },
		{ 'bg-indow-grey-blue-light': backgroundColor == 'grey-blue-light' },
		{ 'bg-indow-pro-grey-light': backgroundColor == 'pro-grey-light' },
		{ 'bg-indow-green': backgroundColor == 'green' },
		{
			'grid grid-cols-1 grid-rows-[auto_auto]! justify-items-center p-0':
				imageColumn,
		},
		{ 'grid-rows-1!': backgroundImage },
		{ 'p-0': backgroundImage },
		{ 'content-grid': !imageColumn },
		{ 'grid-cols-2!': imageColumn },
		{ 'py-10': !imageColumn && !backgroundImage },
	]}
	{style}
>
	{#if backgroundImage}
		<div
			class={[
				`
      full-width absolute z-0 col-span-full row-span-full size-full
      [&_.picture]:contents
    `,
				backgroundImageContainerClass,
			]}
		>
			<Image
				src={backgroundImage}
				class={[
					'col-span-full row-span-full h-full max-w-full! object-cover',
					backgroundImageClass,
				]}
				{loading}
			/>
		</div>
		<div
			class={[
				`z-10 col-span-full row-span-full grid size-full justify-items-center py-10`,
				innerClass,
				{ 'md:col-span-1!': imageColumn },
				{ 'content-grid': imageColumn },
				{ 'md:col-start-2!': columnPosition == 'left' },
			]}
		>
			{#if title}
				<h2>
					{title}
				</h2>
			{/if}
			{@render children?.()}
		</div>
	{:else if imageColumn}
		<div
			class={[
				`
      content-grid z-10 row-span-1 row-start-2 grid w-full justify-items-center
      py-12
      md:col-span-1! md:row-span-full
    `,
				innerClass,
				{ 'md:col-start-2!': columnPosition == 'left' },
				{ 'row-start-1!': imageColumnAfter },
			]}
		>
			{#if title}
				<h2>
					{title}
				</h2>
			{/if}
			{@render children?.()}
		</div>
		<div
			class={[
				`
      relative row-span-1 grid size-full
      md:col-span-1! md:row-span-full
      [&_.picture]:contents
    `,
				{ 'md:col-start-1': columnPosition == 'left' },
			]}
		>
			<Image
				src={imageColumn}
				alt={imageColumnAlt}
				class={['size-full max-w-full', imageColumnClass]}
				{loading}
			/>
		</div>
	{:else}
		{#if title}
			<h2>
				{title}
			</h2>
		{/if}
		{@render children?.()}
	{/if}
</section>
